// frontend/src/api/entity.api.js
import apiClient from "./client.js";

export const getEntities = async (params = {}) => {
  const response = await apiClient.get("/entities", { params });
  return response.data.data;
};

export const getEntity = async (id) => {
  const response = await apiClient.get(`/entities/${id}`);
  return response.data.data;
};

export const syncEntities = async () => {
  const response = await apiClient.post("/entities/sync");
  return response.data.data;
};

export const updateEntityInfo = async (id, data) => {
  const response = await apiClient.put(`/entities/${id}/info`, data);
  return response.data.data;
};

export const updateShareholders = async (id, shareholders) => {
  const response = await apiClient.put(`/entities/${id}/shareholders`, {
    shareholders,
  });
  return response.data.data;
};

export const updatePengurus = async (id, pengurusData) => {
  const response = await apiClient.put(`/entities/${id}/pengurus`, {
    pengurusData,
  });
  return response.data.data;
};

export const uploadEntityDocument = async (entityId, formData) => {
  const response = await apiClient.post(
    `/entities/${entityId}/documents`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return response.data.data;
};

export const updateEntityDocument = async (entityId, docId, data) => {
  const response = await apiClient.patch(
    `/entities/${entityId}/documents/${docId}`,
    data,
  );
  return response.data.data;
};

export const deleteEntityDocument = async (entityId, docId) => {
  const response = await apiClient.delete(
    `/entities/${entityId}/documents/${docId}`,
  );
  return response.data.data;
};

export const getEntityDocumentUrl = async (entityId, docId) => {
  const response = await apiClient.get(
    `/entities/${entityId}/documents/${docId}`,
  );
  return response.data.data;
};

export const getEntityEmailPassword = async (entityId) => {
  const response = await apiClient.get(`/entities/${entityId}/email-password`);
  return response.data.data;
};

export const getEntityGroups = async () => {
  const response = await apiClient.get("/entities/groups");
  return response.data.data;
};

export const getEntityBrands = async () => {
  const response = await apiClient.get("/entities/brands");
  return response.data.data;
};

export const createEntity = async (data) => {
  const response = await apiClient.post("/entities", data);
  return response.data.data;
};

export const updateEntityIdentity = async (id, data) => {
  const response = await apiClient.put(`/entities/${id}/identity`, data);
  return response.data.data;
};

export const deactivateEntity = async (id) => {
  const response = await apiClient.put(`/entities/${id}/deactivate`);
  return response.data.data;
};
